import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { PaymentsService } from '../../services/payments.service';
import { PrintService } from '../../services/print.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import {
	VendorRemitPreviewModalComponent,
	VendorRemitPreviewModalData,
	VendorRemitPreviewTabRequest
} from '../../shared/vendor-remit-preview-modal/vendor-remit-preview-modal.component';

@Component({
	selector: 'app-check-printing',
	templateUrl: './check-printing.component.html',
	styleUrls: ['./check-printing.component.scss']
})
export class CheckPrintingComponent implements OnInit, OnDestroy {
	private routeSub: Subscription | null = null;
	currencies: any[] = [];
	bankAccounts: any[] = [];
	paymentMethods: any[] = [];
	vendorTypes: any[] = [];
	dayPayments: any[] = [];

	selectedCurrency = 'USD';
	currency = 'USD';
	checkNumber = '0';
	postingDate: string = new Date().toISOString().split('T')[0];
	vendorStart: any = null;
	vendorEnd: any = null;
	vendorType = '';
	includeDiscount = '1';
	dueDate: string = new Date(new Date().setDate(new Date().getDate() + 15)).toISOString().split('T')[0];

	color = 'blue';

	paymentForm: FormGroup;
	checkData: any = [];
	checklist: any = {};
	vendorTotals: any = [];
	data: any = [];
	totalDue: any = 0;
	totalDiscount = 0;
	selectedTransactions = 0;
	vendorChecks: {
		[key: string]: boolean } = {};
	vendorDates: {
		[key: string]: string } = {};
	vendorPaymentTypes: {
		[key: string]: string } = {};
	vendorCheckNumbers: {
		[key: string]: string } = {};
	sending: any = false;
	checks: any = [];
	responsePayload: any = [];
	summaryCollapsed = false;
	savedJournal: number | null = null;
	loadedJournal: number | null = null;
	loadedPostings: any = null;
	actionInProgress = false;
	exportingChecklistXls = false;
	exportingChecklistPdf = false;
	config: any = null;
	constructor(
		private globalSearchService: GlobalSearchService,
		private paymentsService: PaymentsService,
		private http: HttpClient,
		private location: Location,
		private formBuilder: FormBuilder,
		private printService: PrintService,
		private router: Router,
		private route: ActivatedRoute,
		private dialog: MatDialog
	) {
		this.color = this.globalSearchService.getColor();

		this.paymentForm = this.formBuilder.group({
			bankaccount: [''],
			currency: [''],
			checkNumber: [''],
			postingDate: [new Date()]
		});
	}

	ngOnInit(): void {
		this.globalSearchService.configsubscription.subscribe(c => { this.config = c; });
		this.config = this.globalSearchService.getConfig();
		const payload = [];
		this.paymentsService.getCheckSetup(payload).subscribe(r => {
			if (r.vendorstart) {}
			this.vendorTypes = r.vendclass || [];
			this.paymentForm.get('checkNumber').setValue(r.CheckNum);
		});
		this.initializeBankAccounts();
		this.initializeCurrencies();
		this.initializePaymentMethods();
		this.fetchTodayPayments();
		this.routeSub = this.route.paramMap.subscribe(paramMap => {
			const journalParam = paramMap.get('journal');
			if (journalParam) {
				const journal = /^\d+$/.test(journalParam) ? parseInt(journalParam, 10) : journalParam;
				this.loadRunForEdit(journal);
			} else {
				this.loadedJournal = null;
				this.loadedPostings = null;
				this.data = [];
				this.checklist = {};
				this.vendorTotals = {};
			}
		});
	}

	ngOnDestroy(): void {
		if (this.routeSub) {
			this.routeSub.unsubscribe();
		}
	}

	loadRunForEdit(journal: number | string): void {
		this.paymentsService.loadRunForEdit({ journal }).subscribe(
			(res: any) => {
				if (!res || !res.success) {
					alert(res?.error || 'Failed to load run.');
					return;
				}
				this.checklist = res.checklist || {};
				this.data = { ...res, checklist: this.checklist };
				this.vendorTotals = res.vendortotals || {};
				this.paymentForm.get('bankaccount')?.setValue(res.bankacct || this.paymentForm.get('bankaccount')?.value);
				this.paymentForm.get('currency')?.setValue(res.currency || this.paymentForm.get('currency')?.value);
				this.paymentForm.get('checkNumber')?.setValue(res.checkNum || this.paymentForm.get('checkNumber')?.value);
				if (res.defCheckPostDate) {
					const d = this.parseDate(res.defCheckPostDate);
					this.paymentForm.get('postingDate')?.setValue(d || new Date());
				}
				this.dueDate = res.duedate || this.dueDate;
				this.vendorDates = res.date && typeof res.date === 'object' ? { ...res.date } : {};
				this.vendorCheckNumbers = res.vendorCheckNumbers && typeof res.vendorCheckNumbers === 'object' ? { ...res.vendorCheckNumbers } : {};
				this.vendorPaymentTypes = res.paymentTypes && typeof res.paymentTypes === 'object' ? { ...res.paymentTypes } : {};
				Object.keys(this.checklist).forEach(vendorKey => {
					const transactions = this.checklist[vendorKey] || [];
					const allSelected = transactions.length > 0 && transactions.every((t: any) => t.selected);
					this.vendorChecks[vendorKey] = allSelected;
				});
				this.loadedJournal = res.journal;
				this.loadedPostings = res.postings || null;
				this.updateTotals();
			},
			(err: any) => {
				alert(err?.error?.error || 'Failed to load run.');
			}
		);
	}

	onVendorStartSelected(vendor: any) {
		if (!vendor || vendor === '') {
			this.vendorStart = '';
			this.normalizeVendorRange();
			return;
		}
		// VendorAutoCompleteComponent emits the vendor object or empty string
		let supplierId = '';
		if (typeof vendor === 'object' && vendor.supplierid) {
			supplierId = vendor.supplierid;
		} else if (typeof vendor === 'string') {
			supplierId = vendor;
		}

		this.vendorStart = supplierId;
		this.normalizeVendorRange();
	}

	onVendorEndSelected(vendor: any) {
		if (!vendor || vendor === '') {
			this.vendorEnd = '';
			this.normalizeVendorRange();
			return;
		}
		// VendorAutoCompleteComponent emits the vendor object or empty string
		let supplierId = '';
		if (typeof vendor === 'object' && vendor.supplierid) {
			supplierId = vendor.supplierid;
		} else if (typeof vendor === 'string') {
			supplierId = vendor;
		}

		this.vendorEnd = supplierId;
		this.normalizeVendorRange();
	}

	normalizeVendorRange() {
		// If both vendors are selected, ensure start <= end (swap if reversed)
		if (this.vendorStart && this.vendorEnd) {
			// Compare vendor IDs alphabetically
			if (this.vendorStart.localeCompare(this.vendorEnd) > 0) {
				// Start is after End alphabetically, swap them
				const temp = this.vendorStart;
				this.vendorStart = this.vendorEnd;
				this.vendorEnd = temp;
			}
		}
	}

	initializeBankAccounts() {
		this.globalSearchService.bankaccounts.subscribe((accounts: any) => {
			this.bankAccounts = accounts || [];
			if (this.bankAccounts.length && !this.paymentForm.get('bankaccount')?.value) {
				this.paymentForm.get('bankaccount')?.setValue(this.bankAccounts[0].accountcode);
			}
		});
	}

	initializeCurrencies() {
		this.globalSearchService.currencies.subscribe((currencies: any) => {
			this.currencies = currencies;
			if (currencies && currencies.length) {
				this.globalSearchService.company.subscribe((company: any) => {
					if (company) {
						this.paymentForm.get('currency')?.setValue(company.currencydefault);
					}
				});
			}
		});
	}

	initializePaymentMethods() {
		this.globalSearchService.payment_methods.subscribe((paymentMethods: any) => {
			this.paymentMethods = paymentMethods || [];
		});
	}

	private normalizePaymentName(s: string): string {
		return (s || '').toLowerCase().replace(/[.\s\-_]/g, '');
	}

	getDefaultPaymentType(): string {
		const cfg = this.config || this.globalSearchService.getConfig();
		const configuredDefault = (cfg?.vendorCheckPrintDefaultPaymentType || '').trim();
		const useEftDefault = configuredDefault === 'EFT' || configuredDefault === 'E-Transfer' || cfg?.env?.client === 'km' || cfg?.env?.client === 'summit';
		const target = useEftDefault
			? (configuredDefault === 'E-Transfer' ? 'etransfer' : 'eft')
			: this.normalizePaymentName(configuredDefault);
		if (target && this.paymentMethods && this.paymentMethods.length) {
			const match = this.paymentMethods.find((m: any) => {
				const name = this.normalizePaymentName(m.paymentname || '');
				return name === target || name.includes(target) || target.includes(name);
			});
			if (match) {
				return match.paymentname || 'Check';
			}
		}
		if (this.paymentMethods && this.paymentMethods.length) {
			return this.paymentMethods[0].paymentname || 'Check';
		}
		return 'Check';
	}

	fetchTodayPayments() {
		const today = new Date().toISOString().split('T')[0];
		this.paymentsService.getPayments(today).subscribe((results: any) => {
			this.dayPayments = results;

		});
	}

	back(): void {
		this.location.back();
	}

	searching = false;

	searchChecks() {
		const vendorTypeValue = (this.vendorType && this.vendorType.toString().trim()) || '';
		const postingVal = this.paymentForm.get('postingDate')?.value;
		const postingDateStr = postingVal instanceof Date ? this.formatDateForPicker(postingVal) : (this.postingDate || '');
		const searchParams = {
			vendorStart: this.vendorStart || '',
			vendorEnd: this.vendorEnd || '',
			vendorType: vendorTypeValue,
			currency: this.paymentForm.get('currency')?.value,
			includeDiscount: this.includeDiscount,
			dueDate: this.dueDate,
			postingDate: postingDateStr
		};
		this.searching = true;
		this.paymentsService.searchChecks(searchParams).subscribe((results: any) => {
			this.searching = false;
			this.checkData = results;
			this.checklist = results.checklist || {};
			this.data = { ...results, checklist: this.checklist };
			this.vendorTotals = results.vendortotals
			//this.totalDue = results.totaldue

			// Get starting check number from form (pre-filled from last check in DB)
			const startingCheckNum = parseInt(this.paymentForm.get('checkNumber')?.value || '0', 10);

			// Initialize check numbers for each vendor, incrementing by 1 for each subsequent vendor
			Object.keys(this.checklist).forEach((vendorKey, index) => {
				this.vendorDates[vendorKey] = this.data.defCheckPostDate;
				this.vendorPaymentTypes[vendorKey] = this.getDefaultPaymentType();
				this.vendorCheckNumbers[vendorKey] = (startingCheckNum + index).toString();
			});

		});
	}

	updateTotals(): void {
		this.totalDue = 0;
		this.totalDiscount = 0;
		this.selectedTransactions = 0;
		if (!this.checklist || typeof this.checklist !== 'object') return;
		Object.keys(this.checklist).forEach(_vendorKey => {
			const transactions = this.checklist[_vendorKey] || [];
			transactions.forEach((transaction: any) => {
				if (transaction.selected) {
					this.totalDue += parseFloat(transaction.bal || 0);
					this.totalDiscount += parseFloat(transaction.disc || 0);
					this.selectedTransactions++;
				}
			});
		});
	}

	updateVendorTotal(vendorKey: string): void {
		this.updateTotals();
	}


	refreshVendor(vendor: string): void {
		// Logic to refresh vendor-specific data
	}
	removeVendor(vendor: string): void {
		delete this.checklist[vendor];
		delete this.vendorTotals[vendor];
		delete this.vendorPaymentTypes[vendor];
		delete this.vendorDates[vendor];
		delete this.vendorCheckNumbers[vendor];
		delete this.vendorChecks[vendor];
		this.updateTotals();
	}
	toggleGroup(vendor: string): void {
		const isChecked = (document.getElementById(`groupcheck-${vendor}`) as HTMLInputElement).checked;
		this.checklist[vendor].forEach((transaction: any) => {
			const checkbox = document.getElementById(`check-${transaction.id}`) as HTMLInputElement;
			checkbox.checked = isChecked;
		});
		this.updateVendorTotal(vendor);
	}

	isDueSoon(dueDate: string): boolean {
		if (!dueDate) return false;
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		const due = new Date(dueDate);
		if (isNaN(due.getTime())) return false;
		due.setHours(0, 0, 0, 0);
		const daysDifference = Math.floor((due.getTime() - today.getTime()) / (1000 * 3600 * 24));
		return daysDifference <= 14 && daysDifference >= 0;
	}

	parseDate(s: string): Date | null {
		if (!s) return null;
		const d = new Date(s);
		return isNaN(d.getTime()) ? null : d;
	}

	formatDateForPicker(d: Date): string {
		return d ? d.toISOString().split('T')[0] : '';
	}


	exportToPDF() {

	}
	applyFilters() {

	}

	refreshVendorData(vendorKey: string): void {
	}

	updateGroupCheck(vendorKey: string): void {
	  const isChecked = this.vendorChecks[vendorKey];
	  const transactions = this.checklist[vendorKey] || [];
	  transactions.forEach((transaction: any) => {
			transaction.selected = isChecked;
	  });
	  this.updateVendorTotal(vendorKey);
	}

	setAllVendorsSelection(selected: boolean): void {
		if (!this.checklist || typeof this.checklist !== 'object') return;
		Object.keys(this.checklist).forEach((vendorKey: string) => {
			this.vendorChecks[vendorKey] = selected;
			const transactions = this.checklist[vendorKey] || [];
			transactions.forEach((t: any) => { t.selected = selected; });
		});
		this.updateTotals();
	}

	allVendorsSelected(): boolean {
		if (!this.checklist || typeof this.checklist !== 'object') return false;
		const keys = Object.keys(this.checklist);
		if (!keys.length) return false;
		return keys.every((vendorKey: string) => {
			const transactions = this.checklist[vendorKey] || [];
			return transactions.length > 0 && transactions.every((t: any) => t.selected);
		});
	}

	updateCheckDate(vendorKey: string): void {
	}

	onDueDateChange(d: Date | null): void {
		this.dueDate = d ? this.formatDateForPicker(d) : '';
	}

	onVendorCheckDateChange(vendorKey: string, d: Date | null): void {
		this.vendorDates[vendorKey] = d ? this.formatDateForPicker(d) : '';
		this.updateCheckDate(vendorKey);
	}

	onCheckNumberChange() {
		// Recalculate all vendor check numbers when the starting check number changes
		const startingCheckNum = parseInt(this.paymentForm.get('checkNumber')?.value || '0', 10);

		// Only recalculate if we have vendors loaded
		if (Object.keys(this.vendorCheckNumbers).length > 0) {
			// Recalculate all vendor check numbers based on new starting number
			Object.keys(this.vendorCheckNumbers).forEach((vendorKey, index) => {
				this.vendorCheckNumbers[vendorKey] = (startingCheckNum + index).toString();
			});
		}
	}

	toggleSummary() {
		this.summaryCollapsed = !this.summaryCollapsed;
	}


	successMessage: string | null = null;

	finalizePostings(): void {
		if (this.actionInProgress) return;
		this.actionInProgress = true;
		const done = () => { this.actionInProgress = false; };
		if (this.loadedJournal != null) {
			this.paymentsService.savePaymentRunForReview(this.buildSavePayload()).subscribe(
				(saveRes: any) => {
					if (!saveRes.success) {
						alert(saveRes.error || 'Failed to save.');
						done();
						return;
					}
					this.paymentsService.loadRunData({ journal: this.loadedJournal }).subscribe(
						(loadRes: any) => {
							if (!loadRes || !loadRes.success || !loadRes.postings) {
								alert(loadRes?.error || 'Failed to load run for posting.');
								done();
								return;
							}
							this.paymentsService.postChecksFinalize({ journal: this.loadedJournal, postings: loadRes.postings }).subscribe(
								(results: any) => {
									if (results.success) {
										this.loadedJournal = null;
										this.loadedPostings = null;
										this.responsePayload = [];
										this.checks = [];
										this.successMessage = 'Payment run posted.';
										this.savedJournal = null;
										this.globalSearchService.showNotification(this.successMessage, 'success', 'bottom', 'right');
										setTimeout(() => { this.successMessage = null; }, 5000);
									} else if (results.error) {
										alert(results.error);
									}
									done();
								},
								(err: any) => {
									alert(err?.error?.error || 'Failed to post.');
									done();
								}
							);
						},
						() => { alert('Failed to load run for posting.'); done(); }
					);
				},
				() => { alert('Failed to save run.'); done(); }
			);
			return;
		}
		const finalizePayload = this.getFinalizePayloadFromPreview();
		if (!finalizePayload) {
			done();
			alert(
				'Nothing to post yet. Use the step that generates checks (Create Print / preview) so journal and payment lines exist, then click Approve & post again.\n\n' +
					'Vendor remittance emails are turned on under Vendors → Remittance email (not on this screen).'
			);
			return;
		}
		this.paymentsService.postChecksFinalize(finalizePayload).subscribe(
			(results: any) => {
				if (results.success) {
					this.responsePayload = [];
					this.checks = [];
					this.successMessage = 'Payment run posted.';
					this.savedJournal = null;
					setTimeout(() => { this.successMessage = null; }, 5000);
				} else if (results.error) {
					alert(results.error);
				}
				done();
			},
			(error: any) => {
				alert(error?.error?.error || 'There was an error processing the payments. Please try again.');
				done();
			}
		);
	}

	/**
	 * After Generate payment run, uses server postings; otherwise builds from the checklist
	 * (selected lines, bal + disc — same as Save for review / Generate payment run).
	 */
	openRemittancePreview(): void {
		const fromPostings = this.getRemitTabsFromFinalizePostings();
		const tabs =
			fromPostings && fromPostings.length
				? fromPostings
				: this.buildRemittanceTabsFromChecklist();
		if (!tabs || !tabs.length) {
			this.globalSearchService.showNotification(
				'Select at least one invoice line, or run Generate payment run first.',
				'info',
				'bottom',
				'right'
			);
			return;
		}
		const title =
			fromPostings && fromPostings.length
				? 'Remittance email preview (from generated payment run)'
				: 'Remittance email preview (from current selection — matches Save for review)';
		this.dialog.open(VendorRemitPreviewModalComponent, {
			width: '760px',
			maxWidth: '98vw',
			data: { title, tabs } as VendorRemitPreviewModalData
		});
	}

	private getRemitTabsFromFinalizePostings(): VendorRemitPreviewTabRequest[] | null {
		const payload = this.getFinalizePayloadFromPreview();
		if (!payload?.postings) return null;
		return this.remitTabsFromPostingsObject(payload.postings);
	}

	private remitTabsFromPostingsObject(postings: any): VendorRemitPreviewTabRequest[] {
		const tabs: VendorRemitPreviewTabRequest[] = [];
		Object.keys(postings).forEach((key) => {
			const post = postings[key];
			if (!post || !post.SupplierID) return;
			const allocs = (post.Allocs || [])
				.filter((a: any) => (parseFloat(a.Amount) || 0) > 0)
				.map((a: any) => ({
					trans_id: +a.TransID,
					amount: Math.round((parseFloat(a.Amount) || 0) * 100) / 100
				}));
			if (!allocs.length) return;
			tabs.push({
				label: `${post.SupplierID} — ${post.PaytReference || key}`,
				supplier_id: String(post.SupplierID),
				context: {
					payment_total: parseFloat(post.AccumBalance) || 0,
					payment_discount: parseFloat(post.AccumDisc) || 0,
					payment_reference: post.PaytReference || '',
					checkno: post.PaytReference || '',
					payment_type: post.PaytType || '',
					post_date: post.PostDate || '',
					bank_account: post.BankAcct || '',
					currency: post.Currency || 'USD'
				},
				allocations: allocs
			});
		});
		return tabs;
	}

	private buildRemittanceTabsFromChecklist(): VendorRemitPreviewTabRequest[] | null {
		if (!this.checklist || typeof this.checklist !== 'object') return null;
		const bank = this.paymentForm.get('bankaccount')?.value || '';
		const currency = this.paymentForm.get('currency')?.value || 'USD';
		const formDate = this.paymentForm.get('postingDate')?.value;
		const defaultPostDate = formDate instanceof Date ? this.formatDateForPicker(formDate) : this.postingDate;
		const tabs: VendorRemitPreviewTabRequest[] = [];
		Object.keys(this.checklist).forEach((vendorKey) => {
			const transactions = this.checklist[vendorKey] || [];
			const allocs: Array<{ trans_id: number; amount: number }> = [];
			let accum = 0;
			let accumDisc = 0;
			transactions.forEach((t: any) => {
				if (!t.selected) return;
				const bal = parseFloat(t.bal) || 0;
				const disc = parseFloat(t.disc) || 0;
				const lineTotal = Math.round((bal + disc) * 100) / 100;
				if (lineTotal > 0 && t.id != null) {
					allocs.push({ trans_id: +t.id, amount: lineTotal });
					accum += bal + disc;
					accumDisc += disc;
				}
			});
			if (!allocs.length) return;
			const postDate = this.vendorDates[vendorKey] || defaultPostDate;
			const ref = (this.vendorCheckNumbers[vendorKey] || '').trim();
			tabs.push({
				label: `${vendorKey} — ${ref || 'ref'}`,
				supplier_id: String(vendorKey),
				context: {
					payment_total: Math.round(accum * 100) / 100,
					payment_discount: Math.round(accumDisc * 100) / 100,
					payment_reference: ref,
					checkno: ref,
					payment_type: this.vendorPaymentTypes[vendorKey] || '',
					post_date: postDate,
					bank_account: bank,
					currency
				},
				allocations: allocs
			});
		});
		return tabs.length ? tabs : null;
	}

	private getFinalizePayloadFromPreview(): { journal: any; postings: any } | null {
		const r = this.responsePayload;
		if (!r || typeof r !== 'object' || Array.isArray(r)) {
			return null;
		}
		const journal = r.journal;
		const postings = r.postings;
		if (journal === undefined || journal === null || String(journal).trim() === '') {
			return null;
		}
		if (!postings || typeof postings !== 'object') {
			return null;
		}
		const n = Array.isArray(postings) ? postings.length : Object.keys(postings).length;
		if (n === 0) {
			return null;
		}
		return { journal, postings };
	}

	saveForReview(): void {
		if (this.selectedTransactions === 0 || this.actionInProgress) return;
		this.actionInProgress = true;
		const payload = this.buildSavePayload();
		this.paymentsService.savePaymentRunForReview(payload).subscribe(
			(results: any) => {
				this.actionInProgress = false;
				if (results.success) {
					this.savedJournal = results.journal;
					this.successMessage = `Run #${results.journal} saved for review.`;
					this.globalSearchService.showNotification(this.successMessage, 'success', 'bottom', 'right');
					setTimeout(() => { this.successMessage = null; this.savedJournal = null; }, 8000);
					if (this.loadedJournal != null) {
						this.paymentsService.loadRunForEdit({ journal: this.loadedJournal }).subscribe((refresh: any) => {
							if (refresh && refresh.success && refresh.postings) {
								this.loadedPostings = refresh.postings;
							}
						});
					}
				} else if (results.error) {
					alert(results.error);
				}
			},
			(error: any) => {
				this.actionInProgress = false;
				alert(error?.error?.error || 'Failed to save for review.');
			}
		);
	}

	private buildSavePayload(): any {
		return {
			reprint: this.loadedJournal != null ? 'true' : 'false',
			journal: this.loadedJournal != null ? this.loadedJournal : (this.paymentForm.get('checkNumber')?.value || ''),
			checkNum: this.paymentForm.get('checkNumber')?.value || '1001',
			date: this.generateVendorDates(),
			payamt: this.generatePayAmounts(),
			discamt: this.generateDiscountAmounts(),
			bankacct: this.paymentForm.get('bankaccount')?.value || '',
			currency: this.paymentForm.get('currency')?.value || 'USD',
			duedate: this.dueDate,
			include: this.generateIncludeMap(),
			vendorCheckNumbers: this.vendorCheckNumbers,
			paymentTypes: this.vendorPaymentTypes
		};
	}

	createPrint(): void {
		if (this.actionInProgress) return;
		this.actionInProgress = true;
		const payload = this.buildSavePayload();
		payload.reprint = this.loadedJournal != null ? 'true' : 'false';
		payload.journal = this.loadedJournal != null ? this.loadedJournal : (this.paymentForm.get('checkNumber')?.value || '');

		this.paymentsService.postChecks(payload).subscribe(
			(results: any) => {
				this.actionInProgress = false;
				this.responsePayload = results;
				this.formatChecks();
				if (this.loadedJournal == null) {
					this.checkData = [];
					this.checklist = {};
					this.data = [];
					this.vendorTotals = [];
					this.totalDue = 0;
				}
			},
			(error: any) => {
				this.actionInProgress = false;
				alert(error?.error?.error || 'There was an error processing the payments. Please try again.');
			}
		);
	}

	printCheck() {
		this.globalSearchService.downloadPdf(this.responsePayload?.base64content, this.responsePayload?.checkNum + '-CheckRun.pdf');
		this.sending = false;
	}

	exportChecklistPdf(): void {
		if (!this.checklist || typeof this.checklist !== 'object' || this.exportingChecklistPdf) return;
		const html = this.buildChecklistHtml();
		if (!html) return;
		this.exportingChecklistPdf = true;
		const encoded = this.globalSearchService.base64encode(html);
		const today = new Date();
		const filename = `payment-run-checklist-${today.toISOString().slice(0, 10)}.pdf`;
		const selectedCount = this.selectedTransactions;
		const subtitle = selectedCount > 0
			? `${selectedCount} selected · Total due $${this.totalDue.toFixed(2)} · Discounts $${this.totalDiscount.toFixed(2)} · ${today.toLocaleString()}`
			: `Created ${today.toLocaleString()}`;
		this.printService.pdf({
			content: encoded,
			filename,
			title: 'Payment Run Checklist (Selected)',
			subtitle
		}).subscribe(
			(result: any) => {
				this.exportingChecklistPdf = false;
				if (result?.content) {
					this.globalSearchService.downloadPdf(result.content, filename);
				} else {
					alert('Could not generate PDF.');
				}
			},
			() => {
				this.exportingChecklistPdf = false;
				alert('Failed to generate PDF.');
			}
		);
	}

	exportChecklistXls(): void {
		if (!this.checklist || typeof this.checklist !== 'object' || this.exportingChecklistXls) return;
		const html = this.buildChecklistHtml();
		if (!html) return;
		this.exportingChecklistXls = true;
		const encoded = this.globalSearchService.base64encode(html);
		const today = new Date();
		const filename = `payment-run-checklist-${today.toISOString().slice(0, 10)}.xlsx`;
		const selectedCount = this.selectedTransactions;
		const subtitle = selectedCount > 0
			? `${selectedCount} selected · Total due $${this.totalDue.toFixed(2)} · Discounts $${this.totalDiscount.toFixed(2)} · ${today.toLocaleString()}`
			: `Created ${today.toLocaleString()}`;
		this.printService.xls({
			content: encoded,
			filename,
			title: 'Payment Run Checklist (Selected)',
			subtitle
		}).subscribe(
			(result: any) => {
				this.exportingChecklistXls = false;
				if (result?.content) {
					this.globalSearchService.downloadXls(result.content, filename);
				} else {
					alert('Could not generate XLS.');
				}
			},
			() => {
				this.exportingChecklistXls = false;
				alert('Failed to generate XLS.');
			}
		);
	}

	private buildChecklistHtml(): string {
		if (!this.checklist || typeof this.checklist !== 'object') return '';
		let html = '<table style="width:100%; border-collapse: collapse;">';
		html += '<thead><tr style="background:#333; color:white;">';
		html += '<th style="padding:4px; text-align:left;">Vendor</th><th style="padding:4px;">Type</th><th style="padding:4px;">Ref</th><th style="padding:4px;">Inv Date</th><th style="padding:4px;">Due Date</th>';
		html += '<th style="padding:4px; text-align:right;">Net</th><th style="padding:4px; text-align:right;">Discount</th><th style="padding:4px; text-align:right;">Amount Due</th></tr></thead><tbody>';
		let totalDue = 0;
		let totalDisc = 0;
		Object.keys(this.checklist).forEach((vendorKey: string) => {
			const transactions = this.checklist[vendorKey] || [];
			const suppname = transactions[0]?.suppname || '';
			transactions.filter((t: any) => t.selected).forEach((t: any) => {
				const net = (parseFloat(t.ovamount) || 0) + (parseFloat(t.ovgst) || 0) + (parseFloat(t.ovfee) || 0);
				const disc = parseFloat(t.disc) || 0;
				const due = parseFloat(t.bal) || 0;
				totalDue += due;
				totalDisc += disc;
				html += '<tr style="border-bottom:1px solid #ddd">';
				html += `<td style="padding:4px">${(vendorKey + ' ' + suppname).replace(/</g, '&lt;')}</td>`;
				html += `<td style="padding:4px">${(t.typename || '').replace(/</g, '&lt;')} (${t.transno || ''})</td>`;
				html += `<td style="padding:4px">${(t.suppreference || '').replace(/</g, '&lt;')}</td>`;
				html += `<td style="padding:4px">${(t.trandate || '').replace(/</g, '&lt;')}</td>`;
				html += `<td style="padding:4px">${(t.duedate || '').replace(/</g, '&lt;')}</td>`;
				html += `<td style="padding:4px; text-align:right">$${net.toFixed(2)}</td>`;
				html += `<td style="padding:4px; text-align:right">$${disc.toFixed(2)}</td>`;
				html += `<td style="padding:4px; text-align:right">$${due.toFixed(2)}</td>`;
				html += '</tr>';
			});
		});
		html += '</tbody><tfoot><tr style="background:#f0f0f0; font-weight:bold; border-top:2px solid #333">';
		html += '<td colspan="6" style="padding:6px; text-align:right">Total selected:</td>';
		html += `<td style="padding:6px; text-align:right">$${totalDisc.toFixed(2)}</td>`;
		html += `<td style="padding:6px; text-align:right">$${totalDue.toFixed(2)}</td></tr></tfoot></table>`;
		return html;
	}
	formatChecks(): void {
		const checks = this.responsePayload?.checks;
		if (checks) {
			this.checks = Object.keys(checks).map((checkNumber) => {
				const checkData = checks[checkNumber];
				return {
					checkNumber,
					postings: checkData.postings,
					check: checkData.check,
					stub: checkData.stub
				};
			});
		}
	}

	// Helper to generate date mapping
	private generateVendorDates(): { [key: string]: string } {
		const formDate = this.paymentForm.get('postingDate')?.value;
		const defaultDate = formDate instanceof Date ? this.formatDateForPicker(formDate) : this.postingDate;
		const dates: { [key: string]: string } = {};
		Object.keys(this.checklist).forEach(vendorKey => {
			dates[vendorKey] = this.vendorDates[vendorKey] || defaultDate;
		});
		return dates;
	}

	// Helper to generate pay amounts mapping
	private generatePayAmounts(): {
		[key: string]: string } {
		const payAmounts: {
			[key: string]: string } = {};
		Object.keys(this.checklist).forEach(vendorKey => {
			this.checklist[vendorKey].forEach((transaction: any) => {
				if (transaction.selected) {
					payAmounts[transaction.id] = transaction.bal || '0.00';
				}
			});
		});
		return payAmounts;
	}

	// Helper to generate discount amounts mapping
	private generateDiscountAmounts(): {
		[key: string]: string } {
		const discountAmounts: {
			[key: string]: string } = {};
		Object.keys(this.checklist).forEach(vendorKey => {
			this.checklist[vendorKey].forEach((transaction: any) => {
				if (transaction.selected) {
					discountAmounts[transaction.id] = transaction.disc || '0.00';
				}
			});
		});
		return discountAmounts;
	}

	// Helper to generate include map
	private generateIncludeMap(): {
		[key: string]: boolean } {
		const includeMap: {
			[key: string]: boolean } = {};
		Object.keys(this.checklist).forEach(vendorKey => {
			this.checklist[vendorKey].forEach((transaction: any) => {
				includeMap[transaction.id] = transaction.selected || false;
			});
		});
		return includeMap;
	}



}